module.exports = __webpack_public_path__ + "static/media/check-green.6cb79043.svg";